<h2 class="title">
  <ng-content></ng-content>
</h2>
